export const FILE_ACCESS = [
  {
    method: 'GET',
    route: 'recordings',
    name: 'Download',
    mapKey: 'DOWNLOAD_URL',
  },

  {
    method: 'GET',
    route: 'recordings',
    name: 'Recordings View',
    mapKey: 'RECORDINGS_VIEW',
  },
];
